import { useCallback, useEffect, useState } from 'react';
import { useApiClient } from './apiClient';

export type TreatmentCatalogConfig = {
  enableServiceVariants: boolean;
};

type CurrentUserPayload = {
  organizationSettings?: {
    treatmentCatalog?: Partial<TreatmentCatalogConfig> | null;
  } | null;
};

export function normalizeTreatmentCatalogConfig(value: unknown): TreatmentCatalogConfig {
  const source = value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {};

  return {
    enableServiceVariants: source.enableServiceVariants === true,
  };
}

export function useTreatmentCatalogConfig() {
  const { fetchJson } = useApiClient();
  const [config, setConfig] = useState<TreatmentCatalogConfig>({ enableServiceVariants: false });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const payload = await fetchJson<CurrentUserPayload>('/users/me');
      setConfig(normalizeTreatmentCatalogConfig(payload.organizationSettings?.treatmentCatalog));
    } catch {
      setConfig({ enableServiceVariants: false });
    } finally {
      setLoading(false);
    }
  }, [fetchJson]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    config,
    loading,
    refresh,
    serviceVariantsEnabled: config.enableServiceVariants,
  };
}